import styled from 'styled-components';

import useBookVenue from '../../../hooks/useBookVenue';
import { useClickBookNowTag } from '../../../tag-manager/booking.tag';
import { colors, mobile, tablet } from '../../styles';

// Lifted above the venue card's stretched title link, so Book Now and its
// tooltip stay clickable. Raised as one block, so the tooltip keeps its own
// stacking relative to the button.
const CardBookContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-end;

  @media (max-width: ${mobile}) {
    margin-top: 16px;
    align-items: center;
  }
`;

const CardCostText = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 1.2;
  flex: 1 1 auto;

  span {
    font-size: 14px;
  }
`;

const BookButton = styled.button`
  font-weight: 500;
  color: white;
  background-color: ${colors.primaryButton};
  font-size: 14px;
  border-radius: 4px;
  padding: 10px 16px;
  border: none;

  @media (max-width: ${tablet}) {
    padding: 9px 13px;
  }

  &:hover {
    opacity: 0.9;
  }
`;

const TooltipBox = styled.div`
  position: absolute;
  visibility: hidden;
  transition: visibility 0.5s, ease-in-out;
`;

const TooltipCard = styled.div`
  position: relative;

  & ${BookButton}:hover + ${TooltipBox} {
    visibility: visible;
    color: #fff;
    background-color: #59686f;
    width: 100px;
    padding: 8px 8px;
    border-radius: 4px;
  }
`;

const BookNow = ({ venue }) => {
  const onBookClick = useBookVenue(venue);

  const handleClick = (e) => {
    if (onBookClick) {
      onBookClick(e);
    }
    useClickBookNowTag({ label: 'Book Now List' });
  };

  return (
    <CardBookContent>
      <CardCostText>
        ${Number(venue.dayPrice.replace('$', '')).toLocaleString()}
        <span> / day</span>
      </CardCostText>
      <TooltipCard>
        <BookButton onClick={handleClick}>Book Now</BookButton>
      </TooltipCard>
    </CardBookContent>
  );
};

export default BookNow;
